import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
const createSchema = Yup.object().shape({
  comment: Yup.string().min(3).required()
});
const defaultValues = {
  comment: ""
};
const useIgnoreForm = () => {
  return useForm({
    mode: "onChange",
    resolver: yupResolver(createSchema),
    reValidateMode: "onChange",
    defaultValues,
    shouldUnregister: true
  });
};
export {
  useIgnoreForm
};
